import AttachCardStep from './steps/AttachCardStep';
import PolicyScheduleStep from './steps/PolicyScheduleStep';

export const STEP_IDS = {
  POLICY: 'policy',
  ATTACH: 'attach-card',
};

export const steps = [
  {
    n: 1,
    icon: 'payment',
    id: STEP_IDS.POLICY,
    label: 'recurringPayment.steps.paymentsSchedule',
    content: PolicyScheduleStep,
  },
  {
    n: 2,
    icon: 'payment',
    id: STEP_IDS.ATTACH,
    label: 'recurringPayment.steps.payment',
    content: AttachCardStep,
  },
  {
    n: 3,
    icon: 'checkmark',
    id: 'confirmation',
    label: 'recurringPayment.steps.confirmation',
    content: () => null,
  },
];

export default steps;
